export const Constants = {
  Cookies: {
    BASE_API_URL: "http://localhost:4000",
    PRIVILEGE: "privilege",
    API_ACCESS: "access_level",
    API_TOKEN_KEY: "eaodesigns",
    USERNAME: "username",
    USERDETAILS: "userdetails",
    DATEDETAILS: "datedetails",
    DEPARTMENT: "department",
    API_COMMENT:
      "E.A.O Designs - 233543425046. Contact us for any kind of software related project. Mobile apps, Websites, Desktop Applications and Draphic Designs.",
  },
  // MINIMUM_WIDTH: 1160,
  MINIMUM_WIDTH: 960,
};
